import { useEntityUrl } from 'framework/routing';

export const WASTE_PATH = '/waste';
export const WASTE_RESOURCE_URL = '/accounting-cycle/waste';

const useWasteUrl = () => {
  return useEntityUrl({
    baseLink: WASTE_PATH,
  });
};

export default useWasteUrl;
